module.exports = __webpack_public_path__ + "static/img/401.089007e.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/401.gif
// module id = 544
// module chunks = 0